import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  {
    title: 'pages.onboarding.concernFeedback.motivated',
    subtitle: 'pages.onboarding.concernFeedback.motivatedSub',
    value: 'motivated',
  },
  {
    title: 'pages.onboarding.concernFeedback.unsettled',
    subtitle: 'pages.onboarding.concernFeedback.unsettledSub',
    value: 'unsettled',
  },
  {
    title: 'pages.onboarding.concernFeedback.impressedUneasy',
    subtitle: 'pages.onboarding.concernFeedback.impressedUneasySub',
    value: 'impressed-uneasy',
  },
  {
    title: 'pages.onboarding.concernFeedback.frustrated',
    subtitle: 'pages.onboarding.concernFeedback.frustratedSub',
    value: 'frustrated',
  },
  {
    title: 'pages.onboarding.concernFeedback.notHappened',
    subtitle: 'pages.onboarding.concernFeedback.notHappenedSub',
    value: 'not-happened',
  },
]

export default function ConcernFeedbackPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.concernFeedback.title"
    />
  )
}
